import { render, staticRenderFns } from "./products-bulk-price-edit-modal.vue?vue&type=template&id=1930e5f9&scoped=true"
import script from "./products-bulk-price-edit-modal.vue?vue&type=script&lang=js"
export * from "./products-bulk-price-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./products-bulk-price-edit-modal.vue?vue&type=style&index=0&id=1930e5f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1930e5f9",
  null
  
)

export default component.exports